import React from "react";
import { Modal, Table } from "antd";
import { useTranslation } from "react-i18next";
import "./PaymentDetailsModal.css"; // Import custom styles for better structure

const PaymentDetailsModal = ({ isModalOpen, handleCancel, data }) => {
  const { t } = useTranslation();

  const maskCardNumber = (cardNumber) => {
    if (!cardNumber || cardNumber.length < 4) return cardNumber;
    const lastFour = cardNumber.slice(-4);
    const masked = "*".repeat(cardNumber.length - 4) + lastFour;
    return masked;
  };

  const renderContent = () => {
    if (!data) {
      return <div>{t("paymentDetailsModal.noData")}</div>;
    }

    if (data?.handheldPayment?.merchantReceipt) {
      return (
        <div className="receipt-container">
          <h3 className="receipt-title">{t("paymentDetailsModal.receiptTitle")}</h3>
          <div
            className="receipt-content styled-receipt"
            dangerouslySetInnerHTML={{ __html: data.handheldPayment.merchantReceipt.replace(/\n\s*/g, "")}}
          ></div>
        </div>
      );
    } else if (data?.payment) {
      const paymentData = Object.entries(data.payment).map(([key, value]) => ({
        key: t(`paymentDetailsModal.${key}`) || key,
        value: key === "cardNumber" ? maskCardNumber(value) : value,
      }));

      const columns = [
        {
          title: t("paymentDetailsModal.key"),
          dataIndex: "key",
          key: "key",
          render: (text) => <strong>{text}</strong>,
        },
        {
          title: t("paymentDetailsModal.value"),
          dataIndex: "value",
          key: "value",
        },
      ];

      return <Table dataSource={paymentData} columns={columns} pagination={false} showHeader={false} />;
    }
    return <div>{t("paymentDetailsModal.noData")}</div>;
  };

  return (
    <Modal
      title={t("paymentDetailsModal.title")}
      visible={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      style={{ maxHeight: "600px" }}
    >
      {renderContent()}
    </Modal>
  );
};

export default PaymentDetailsModal;
